export var stepByStepLayouts = [{
        key: 'vertical',
        imgSrc: ''
    }, {
        key: 'horizontal',
        imgSrc: ''
    }];
